import React from 'react';

/** renders the multi campaign on the home page */
function VerticalSpace(props) {
    return (
        <div style={{height:props.primary['height'],clear:'both',display:'block'}}></div>
    );
}
export default VerticalSpace;